export type VideoFormatType = 'default' | 'youtube' | 'google-drive' | 'one-drive' | 'dartfish' | 'vimeo';

export enum VideoFormat {
    DEFAULT = 'default',
    YOUTUBE = 'youtube',
    GOOGLE_DRIVE = 'google-drive',
    ONE_DRIVE = 'one-drive',
    VIMEO = 'vimeo',
    DARTFISH = 'dartfish'
}

export type VideoDisplayType = 'video' | 'iframe';

export enum VideoDisplay {
    VIDEO = 'video',
    IFRAME = 'iframe'
}
